import Spinner from '@berlitz/spinner'
import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  margin: ${({ height, theme }) => (height ? height : theme.layout.xxl)} auto 0;
  display: flex;
  align-items: center;
  align-content: center;
  width: ${({ theme }) => theme.layout.lg};
  height: ${({ theme }) => theme.layout.lg};
  padding: 16px;
  border-radius: ${({ theme }) => theme.radius.sm};
  background-color: ${({ theme }) => theme.palette.white};
`

export const StyledSpinner = styled(Spinner)`
  display: block;
  text-align: center;
  margin: 0 auto;
`
